import React, { useState, useEffect } from "react";
import AnalysePage from "./AnalysePage";
import { createFragmentContainer, graphql } from "react-relay";
import { timeDifferenceForDate } from "./utils";

const model = require("wink-eng-lite-web-model");
const nlp = require("wink-nlp")(model);
const its = require("wink-nlp/src/its.js");
var stats = require("wink-statistics");

function AnalysePageWrapper(props) {
    const [vector, setVector] = useState(null);
    const [postsTfidf, setPostsTfidf] = useState(null);
    const [sentimentScore, setSentimentScore] = useState([]);
    const [sentimentTrend, setSentimentTrend] = useState([]);
    const [keywords, setKeywords] = useState([]);
    const [meanSentiment, setMeanSentiment] = useState(0);
    const [sentimentPercent, setSentimentPercent] = useState([
        { score: "positive", value: 0 },
        { score: "neutral", value: 0 },
        { score: "negative", value: 0 },
    ]);

    let postArr = props.analyse_Posts.edges.map((edge) => edge.node.title);
    let postArrId = props.analyse_Posts.edges.map((edge) => edge.node.id);
    // let postArrWithIndex = props.analyse_Posts.edges.map((edge) => ({
    //     id: edge.node.id,
    //     title: edge.node.title,
    // }));
    let postArrayDt = props.analyse_Posts.edges.map(
        (edge) => edge.node.created
    );
    let postArrayTitle = props.analyse_Posts.edges.map(
        (edge) => edge.node.title
    );
    const corpus = postArr;
    let keyPhrases = [];
    let terms = [];
    let termArr = [];
    let entityList = [];
    let data = null;
    let sentimentScoreList = [];
    let sentimentTrendList = [];
    let sentimentValuesList = [];

    function calculateSentimentPercent() {
        let positiveCount = 0;
        let negativeCount = 0;
        let neutralCount = 0;
        let totalSentiments = sentimentValuesList.length;

        for (let i = 0; i < totalSentiments; i++) {
            if (sentimentValuesList[i] > 0) {
                positiveCount++;
            } else if (sentimentValuesList[i] < 0) {
                negativeCount++;
            } else {
                neutralCount++;
            }
        }

        let positivePercent = Math.floor(
            (positiveCount / totalSentiments) * 100
        );
        let negativePercent = Math.floor(
            (negativeCount / totalSentiments) * 100
        );
        let neutralPercent = Math.floor((neutralCount / totalSentiments) * 100);

        setSentimentPercent([
            { score: "positive:", value: positivePercent },
            { score: "negative", value: negativePercent },
            { score: "neutral", value: neutralPercent },
        ]);
    }

    function calculateSentiment() {
        corpus.forEach((doc, index) => {
            doc = nlp.readDoc(doc);
            const sentiment = doc.out(its.sentiment);
            const released = timeDifferenceForDate(postArrayDt[index]);
            sentimentValuesList.push(sentiment);
            sentimentScoreList.push({
                postId: postArrId[index],
                postReleased: released,
                postTitle: postArrayTitle[index],
                sentiment: sentiment,
            });

            if (sentiment > 0) {
                sentimentTrendList.push({
                    index: index,
                    sentiment: "positive",
                });
            } else {
                sentimentTrendList.push({
                    index: index,
                    sentiment: "negative",
                });
            }
        });
        let m = stats.data.mean(Object.values(sentimentValuesList));
        setMeanSentiment(m);
        setSentimentScore(sentimentScoreList);
        setSentimentTrend(sentimentTrendList);
        calculateSentimentPercent();
    }

    useEffect(() => {
        const bm25 = require("wink-nlp/utilities/bm25-vectorizer")();

        corpus.forEach((doc) => {
            bm25.learn(
                nlp
                    .readDoc(doc)
                    .tokens()
                    .filter(
                        (t) =>
                            t.out(its.type) === "word" &&
                            !t.out(its.stopWordFlag) &&
                            t.out(its.pos) === "NOUN"
                    )
                    .out()
            );

            const entities = getCustomEntities(doc);
            entityList = entityList.concat(entities);
        });

        data = bm25.out(its.tfidf);
        termArr = getTerms(0);
        setPostsTfidf(terms);
        keyPhrases = getKeyPhrases();
        setVector(keyPhrases);
        setKeywords(termArr);
        calculateSentiment();


        return () => {
            const bm25 = null;
            termArr = [];
            keyPhrases = [];
            setPostsTfidf([]);
        };
    }, []);

    function getKeyPhrases() {
        let phraseSet = new Set();
        for (let i = 0; i < entityList.length; i++) {
            for (let j = 0; j < termArr.length; j++) {
                if (entityList[i].search(termArr[j]) !== -1) {
                    phraseSet.add(entityList[i]);
                }
            }
        }
        let phrases = Array.from(phraseSet);
        return phrases;
    }

    function getTerms(threshold) {
        let frequentTermSet = new Set();
        let termValueSet = new Set();
        let termSet = new Set();

        if (data != null) {
            for (var i = 0; i < data.length; i++) {
                for (var j = 0; j < Object.keys(data[i]).length; j++) {
                    let term = Object.keys(data[i])[j];
                    let value = Object.values(data[i])[j];

                    termSet.add(term);
                    terms.push({
                        term: term,
                        value: value,
                    });

                    if (Object.values(data[i])[j] > threshold) {
                        let frequentTerm = Object.keys(data[i])[j];
                        frequentTermSet.add(frequentTerm);
                    }
                }
            }
        }

        let termArr = Array.from(frequentTermSet);
        return termArr;
    }

    function getCustomEntities(doc) {
        const patterns = [
            {
                name: "nounPhrase",
                patterns: [
                    "[NOUN] [VERB] [|NOUN] [|VERB]",
                    "[|PROPN] [NOUN] [|ADV] [VERB] [|ADV]",
                    "[|NOUN] [|CARDINAL] [|PROPN] [NOUN] [|PROPN] [|ADJ] [|VERB] [|PROPN] [NOUN] [|NOUN] [|ADJ]",
                ],
            },
        ];

        nlp.learnCustomEntities(patterns);
        const doc_ent = nlp.readDoc(doc);
        let entities = doc_ent.customEntities().out();
        return entities;
    }

    return (
        <>
            <AnalysePage
                user={props.user}
                settings={props.settings}
                keyPhrases={vector}
                postsTfidf={postsTfidf}
                sentimentScore={sentimentScore}
                sentimentTrend={sentimentTrend}
                keywords={keywords}
                meanSentiment={meanSentiment}
                sentimentPercent={sentimentPercent}
            />
        </>
    );
}

export default createFragmentContainer(AnalysePageWrapper, {
    analyse_Posts: graphql`
        fragment AnalysePageWrapper_analyse_Posts on PostNodeConnection {
            edges {
                node {
                    id
                    title
                    created
                    body
                }
            }
        }
    `,
});
